import { Routes } from '@angular/router';
import {HomeComponent} from './pages/home/home.component';
import {NewsComponent} from './pages/news/news.component';
import {NewsDetailsComponent} from './pages/news-details/news-details.component';
import {AmbassadorsComponent} from './pages/ambassadors/ambassadors.component';
import {PartnersComponent} from './pages/partners/partners.component';
import {MatchsComponent} from './pages/matchs/matchs.component';
import {ClubComponent} from './pages/club/club.component';
import {MemberDetailsComponent} from './pages/member-details/member-details.component';
import {GalleryComponent} from '@/app/pages/gallery/gallery.component';
import {GalleryDetailsComponent} from '@/app/pages/gallery-details/gallery-details.component';
import {CguComponent} from '@/app/pages/cgu/cgu.component';
import {PrivacyComponent} from '@/app/pages/privacy/privacy.component';
import {RosterOverwatchProComponent} from '@/app/pages/rosters/roster-overwatch-pro/roster-overwatch-pro.component';
import {
	RosterOverwatchAcademyComponent
} from '@/app/pages/rosters/roster-overwatch-academy/roster-overwatch-academy.component';
import {CallbackTokenComponent} from '@/app/pages/login/callback-token/callback-token.component';
import {NotFoundComponent} from '@/app/pages/not-found/not-found.component';
import {AuthenticatedGuard} from '@/app/core/guard/authenticated.guard';
import {BetComponent} from '@/app/pages/bet/bet.component';
import {BetLeaderboardComponent} from '@/app/pages/bet-leaderboard/bet-leaderboard.component';
import {featureFlagGuard} from '@/app/core/guard/feature-flag.guard';
import {RosterPokemonVgcComponent} from '@/app/pages/rosters/roster-pokemon-vgc/roster-pokemon-vgc.component';
import {PPlaceComponent} from '@/app/pages/p-place/p-place.component';
import { RosterPokemonUniteComponent } from "./pages/rosters/roster-pokemon-unite/roster-pokemon-unite.component";
import {BattlePepsComponent} from '@/app/pages/battlepeps/battlepeps.component';
import {RosterDofusComponent} from '@/app/pages/rosters/roster-dofus/roster-dofus.component';
import {ShopComponent} from '@/app/pages/tcg/shop/shop.component';
import {MarketplaceComponent} from '@/app/pages/tcg/marketplace/marketplace.component';
import {MarketplaceMaintenanceComponent} from '@/app/pages/tcg/marketplace-maintenance/marketplace-maintenance.component';
import {marketplaceEnabledGuard, marketplaceMaintenanceGuard} from '@/app/core/guard/marketplace.guard';
import {ProfileComponent} from '@/app/pages/profile/profile.component';
import {PublicProfileComponent} from '@/app/pages/public-profile/public-profile.component';
import {RosterSportComponent} from '@/app/pages/rosters/roster-sport/roster-sport.component';

export const routes: Routes = [
	{
		path: '',
		component: HomeComponent,
		data: {
			seo: {
				titleKey: 'page.home.seo-title',
				descriptionKey: 'page.home.seo-description'
			}
		},
	},
	{
		path: 'roster',
		children: [
			{
				path: "",
				redirectTo: "/",
				pathMatch: "full"
			},
			{
				path: 'overwatch',
				children: [
					{
						path: 'pro',
						component: RosterOverwatchProComponent,
						data: {
							seo: {
								titleKey: 'page.roster.overwatch-pro.seo-title',
								descriptionKey: 'page.roster.overwatch-pro.seo-description'
							}
						},
					},
					{
						path: 'academy',
						canMatch: [featureFlagGuard('OVERWATCH_ACADEMY')],
						component: RosterOverwatchAcademyComponent,
						data: {
							seo: {
								titleKey: 'page.roster.overwatch-academy.seo-title',
								descriptionKey: 'page.roster.overwatch-academy.seo-description'
							}
						},
					}
				]
			},
			{
				path: 'dofus',
				component: RosterDofusComponent,
				data: {
					seo: {
						titleKey: 'page.roster.dofus.seo-title',
						descriptionKey: 'page.roster.dofus.seo-description'
					}
				},
			},
			{
				path: 'sport',
				component: RosterSportComponent,
				data: {
					seo: {
						titleKey: 'page.roster.sport.seo-title',
						descriptionKey: 'page.roster.sport.seo-description'
					}
				},
			},
			{
				path: 'pokemon',
				children: [
					{
						path: 'vgc',
						canMatch: [featureFlagGuard('POKEMON_VGC')],
						component: RosterPokemonVgcComponent,
						data: {
							seo: {
								titleKey: 'page.roster.pokemon-vgc.seo-title',
								descriptionKey: 'page.roster.pokemon-vgc.seo-description'
							}
						},
					},
					{
						path: 'unite',
						canMatch: [featureFlagGuard('POKEMON_UNITE')],
						component: RosterPokemonUniteComponent,
						data: {
							seo: {
								titleKey: 'page.roster.pokemon-unite.seo-title',
								descriptionKey: 'page.roster.pokemon-unite.seo-description'
							}
						},
					},
				]
			},
		]
	},
	{
		path: 'player/:memberId',
		component: MemberDetailsComponent
	},
	{
		path: 'news',
		children: [
			{
				path: '',
				component: NewsComponent,
				data: {
					seo: {
						titleKey: 'page.news.seo-title',
						descriptionKey: 'page.news.seo-description'
					}
				},
			},
			{
				path: ':articleId',
				component: NewsDetailsComponent,
			}
		]
	},
	{
		path: 'gallery',
		children: [
			{
				path: '',
				component: GalleryComponent,
				data: {
					seo: {
						titleKey: 'page.gallery.seo-title',
						descriptionKey: 'page.gallery.seo-description'
					}
				},
			},
			{
				path: ':galleryId',
				component: GalleryDetailsComponent,
			}
		]
	},
	{
		path: 'ambassadors',
		component: AmbassadorsComponent,
		data: {
			seo: {
				titleKey: 'page.ambassadors.seo-title',
				descriptionKey: 'page.ambassadors.seo-description'
			}
		},
	},
	{
		path: 'partners',
		component: PartnersComponent,
		data: {
			seo: {
				titleKey: 'page.partners.seo-title',
				descriptionKey: 'page.partners.seo-description'
			}
		},
	},
	{
		path: 'matchs',
		component: MatchsComponent,
		data: {
			seo: {
				titleKey: 'page.matchs.seo-title',
				descriptionKey: 'page.matchs.seo-description'
			}
		},
	},
	{
		path: 'club',
		component: ClubComponent,
		data: {
			seo: {
				titleKey: 'page.club.seo-title',
				descriptionKey: 'page.club.seo-description'
			}
		},
	},
	{
		path: 'cgu',
		component: CguComponent,
		data: {
			seo: {
				titleKey: 'page.cgu.seo-title',
				descriptionKey: 'page.cgu.seo-description'
			}
		},
	},
	{
		path: 'confidentialite',
		component: PrivacyComponent,
		data: {
			seo: {
				titleKey: 'page.privacy.seo-title',
				descriptionKey: 'page.privacy.seo-description'
			}
		},
	},
	{
		path: 'auth',
		children: [
			{
				path: 'token',
				component: CallbackTokenComponent,
			}
		]
	},
	{
		path: 'profil',
		component: ProfileComponent,
		canActivate: [AuthenticatedGuard],
	},
	{
		path: 'profil/:username',
		component: PublicProfileComponent,
	},
	{
		path: 'bet',
		canMatch: [featureFlagGuard('BETTING')],
		children: [
			{
				path: "",
				redirectTo: "matches",
				pathMatch: "full"
			},
			{
				path: 'matches',
				component: BetComponent,
			},
			{
				path: 'leaderboard',
				component: BetLeaderboardComponent,
			}
		]
	},
	{
		path:'place',
		canMatch: [featureFlagGuard('P_PLACE')],
		component: PPlaceComponent,
	},
	{
		path: 'battlepeps',
		canMatch: [featureFlagGuard('BATTLEPEPS')],
		component: BattlePepsComponent
	},
	{
		path: 'collection',
		children: [
			{
				path: 'shop',
				component: ShopComponent
			},
			{
				path: 'marketplace/maintenance',
				canMatch: [marketplaceMaintenanceGuard],
				component: MarketplaceMaintenanceComponent
			},
			{
				path: 'marketplace',
				canMatch: [marketplaceEnabledGuard],
				component: MarketplaceComponent
			}
		]
	},
	{
		path: 'games',
		component: ProfileComponent,
	},
	{
		path: '**',
		redirectTo: 'not-found',
	},
	{
		path: 'not-found',
		component: NotFoundComponent,
		data: {
			seo: {
				titleKey: 'page.not-found.seo-title',
				descriptionKey: 'page.not-found.seo-description',
				noindex: true
			}
		},
	}

];
